import React from "react";

const ChevronRight = ({
    width = 7,
    height = 14,
    color = "#70707A",
    ...rest
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 7 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <g clipPath="url(#clip0_2317_7360)">
                <path fillRule="evenodd" clipRule="evenodd" d="M0.96257 0.936277C1.21429 0.720516 1.59326 0.749668 1.80902 1.00139L6.61142 6.60418C6.80411 6.82899 6.80411 7.16072 6.61142 7.38552L1.80902 12.9883C1.59326 13.24 1.21429 13.2692 0.96257 13.0534C0.710849 12.8377 0.681698 12.4587 0.897459 12.207L5.36499 6.99485L0.897459 1.78273C0.681698 1.53101 0.710849 1.15204 0.96257 0.936277Z" fill={color} />
            </g>
            <defs>
                <clipPath id="clip0_2317_7360">
                    <rect width="6.00301" height="12.4062" fill="white" transform="translate(0.75293 0.791748)" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default ChevronRight;